import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationPipe } from './pipes/translation/translation.pipe';
import { StakeInputComponent } from '../stake-input/stake-input.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [TranslationPipe, StakeInputComponent],
    exports: [TranslationPipe, StakeInputComponent]
})
export class SharedModule {
}


// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/shared.module.ts